module.exports = __webpack_public_path__ + "img/appicon-1024-x-1024.49712908.png";